import { FC } from "react";
import { Outlet } from "react-router";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { isMobile } from "react-device-detect";
import HeaderMobile from "../components/HeaderMobile";
import FooterMobile from "../components/FooterMobile";
import { observer } from "mobx-react-lite";
import appStore from "../stores/appStore";
import CookieConsent from "../components/CookieConsent";

const DefaultLayout: FC = () => {
  return (
    <>
      {/* <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.1)'
        }} /> */}
      {isMobile ? <HeaderMobile></HeaderMobile> : <Header></Header>}

      <main className="w-full max-w-[1440px] ml-auto mr-auto">
        <Outlet></Outlet>
        {!appStore.cookieConsentAccepted && (
          <CookieConsent onAccept={() => appStore.acceptCookieConsent()} />
        )}
      </main>
      <div> 
      </div>
      {!isMobile ? <Footer></Footer> : <FooterMobile></FooterMobile>}
    </>
  );
};

export default observer(DefaultLayout);
